module.exports = __webpack_public_path__ + "static/media/wallet.d6a0b8a7.svg";